module.exports = __webpack_public_path__ + "img/swisslife.d279bbb4.png";